// В.2.c: В карантин! (liv_v_karantin, common Действие, Лив Лайф).
// «Даёт союзному юниту Скрытность и полностью его излечивает».
//
// Picker: только СВОИ юниты на поле. Если своих юнитов нет — сгорает.
//
// Эффект:
//   1) addPermanentKeyword(target, 'stealth', cardId).
//      Скрытность работает по обычным правилам: снимается при первой
//      атаке юнита через activateStealthUnit (диздок 6.7).
//   2) healUnit(target, max_hp - current_hp, cardId) — полное лечение.
//      Если цель уже на полном ХП → actualAmount=0, событие healed
//      не эмитится (это нормально, главное — Скрытность применена).

import { addPermanentKeyword } from '../../keywords/permanent.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_v_karantin';
const LABEL = 'В карантин!';

registerImplementedAbility(CARD_ID, 'oneshot');

export function actionTargets(state, playerIdx) {
  const me = state.players?.[playerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u => u.type === 'unit');
}

export function resolve(state, playerIdx, target /*, opts */) {
  const me = state.players?.[playerIdx];
  const ownUnits = me ? me.unitsOnField().filter(u => u.type === 'unit') : [];
  if (ownUnits.length === 0) {
    state.log?.add(`📋 ${LABEL}: нет цели — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  if (!target || !target.isAlive || !target.isAlive() ||
      target.type !== 'unit' || target.ownerId !== playerIdx) {
    state.log?.add(`📋 ${LABEL}: цель недоступна — Действие сгорает`);
    return { ok: true, skipped: true };
  }
  // 1) Скрытность.
  addPermanentKeyword(state, target, 'stealth', CARD_ID, LABEL);
  // 2) Полное лечение: amount = max_hp - current_hp.
  const max = target.base?.hp ?? 0;
  const cur = target.current?.hp ?? 0;
  const need = Math.max(0, max - cur);
  healUnit(state, target, need, target.name_ru ? { id: CARD_ID, name_ru: LABEL, type: 'action' } : LABEL);
  state.log?.add(
    `📋 ${LABEL} → ${target.name_ru} [${me.name}]: Скрытность + полное лечение`
  );
  return { ok: true };
}
